// noinspection CommaExpressionJS

import commonStyles from '../../css/common.pcss.json'
import { wait } from './helpers'
import Api from '../api'

declare global {
  // noinspection JSUnusedGlobalSymbols
  interface Window {
    showGoogleAds: boolean,
    yaContextCb: Array<() => void>,
  }
}

const yaMetrica = () => {
  (function (m, e, t, r, i, k, a) {
    m[i] = m[i] || function () {
      (m[i].a = m[i].a || []).push(arguments)
    }; // @ts-ignore
    m[i].l = 1 * new Date();
    k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
  })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
  ym(36906115, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
    trackHash: true,
    triggerEvent: true,
    params: {
      logged_in: window.isLoggedIn ? 'Пользователь' : 'Гость'
    }
  });
}

const adSense = () => {
  if (window.showGoogleAds) {
    /* const gAd = document.createElement('script')
    gAd.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'
    gAd.async = true
    gAd.setAttribute('data-ad-client', 'ca-pub-1080313816307993')
    document.head.appendChild(gAd) */
  }
}

const adFox = () => {
  if (document.body.hasAttribute('data-noads')) {
    return
  }
  window.yaContextCb = window.yaContextCb || []
  const script = document.createElement('script')
  script.src = 'https://yandex.ru/ads/system/context.js'
  script.defer = true
  script.async = true
  script.addEventListener('load', () => {
    window.dispatchEvent(new Event('adfoxLoaded'))
  })
  script.addEventListener('error', () => {
    removeBodyBg()
  })
  document.body.append(script)
}

const removeBodyBg = () => {
  document.body.style.removeProperty('background-image')
  document.body.style.removeProperty('background-color')
  Api.post({
    url: 'ads/branding',
    body: {
      image: null,
      color: null
    }
  })
    .catch(() => {
      // Не удалось отправить данные
      // Ну и ладно
    })
}

const adFoxFade = () => {
  const body = document.querySelector('body')
  let hasClickable = false
  const observer = new MutationObserver(() => {
    if (body.classList.contains('adfoxClickable') && !hasClickable) {
      hasClickable = true
      const bodyBG = body.style.backgroundImage.replace(/^url\("/, '').replace(/"\)$/, '')
      const img = document.createElement('img')
      img.onerror = () => {
        body.style.removeProperty('background-color')
        const fakeContentShifter = document.querySelector<HTMLDivElement>(`#${commonStyles['fakeContentShifter']}`)
        fakeContentShifter?.style.setProperty('height', '0');
        Api.post({
          url: 'ads/branding',
          body: {
            image: 'none'
          }
        })
          .catch(() => {
            // Не удалось отправить данные
            // Ну и ладно
          })
      }
      let branding = document.querySelector<HTMLElement>('.branding')
      if (branding) {
        if (branding.style.backgroundImage === body.style.backgroundImage) {
          console.log('branding already exists')
          body.style.removeProperty('background-image')
          body.style.removeProperty('background-attachment')
          img.src = bodyBG
          return
        } else {
          branding.remove()
        }
      }
      img.src = bodyBG
      img.onload = async () => {
        body.style.setProperty('background-color', backgroundColor)
        branding.style.setProperty('background-image', `url('${img.src}')`);
        body.classList.add('bgLoaded')
        if (!contentShifter) {
          // Нет контент шифтера — нет проблем
          return
        }
        const fullWidthHeight = contentShifter.style.getPropertyValue('height');
        let fakeContentShifter = document.querySelector<HTMLDivElement>(`#${commonStyles['fakeContentShifter']}`)
        if (!fakeContentShifter) {
          fakeContentShifter = document.createElement('div')
          fakeContentShifter.id = commonStyles['fakeContentShifter']
          fakeContentShifter.classList.add('adver')
          fakeContentShifter.style.setProperty('height', '0')
          body.insertBefore(fakeContentShifter, document.querySelector('#main-content'))
          await wait(100)
        }
        fakeContentShifter?.style.setProperty('height', fullWidthHeight);
        Api.post({
          url: 'ads/branding',
          body: {
            image: img.src,
            color: backgroundColor
          }
        })
          .catch(() => {
            // Не удалось отправить данные
            // Ну и ладно
          })
      }
      const contentShifter = document.querySelector<HTMLDivElement>('#contentShifter')
      branding = document.createElement('div')
      branding.classList.add('branding')
      document.body.insertBefore(branding, contentShifter)
      const backgroundColor = body.style.getPropertyValue('background-color')
      body.style.removeProperty('background-image')
      body.style.removeProperty('background-color')
    }
  })
  observer.observe(body, {
    attributes: true,
    attributeFilter: ['class', 'style']
  })
}

export default () => {
  yaMetrica()
  adSense()
  adFoxFade()
  setTimeout(adFox, 100)
}
